import { useState, useRef } from 'react'
import Box from '@mui/joy/Box'
import Modal from '@mui/joy/Modal'
import ModalDialog from '@mui/joy/ModalDialog'
import ModalClose from '@mui/joy/ModalClose'
import Sheet from '@mui/joy/Sheet'
import { SchedulerForm } from './SchedulerForm'
import { CampaignAPI } from '../api/CampaignAPI'
import { Loading } from './ui/Loading'
import { FilePickerButton } from './ui/FilePickerButton'
import { BlobAPI } from '../api/BlobAPI'
import { MediaContainer } from './MediaContainer'
import { DeterminateProgress } from './ui/DeterminateProgress'
import _ from 'lodash'
import { ModalOverflow } from '@mui/joy'

const ALLOWED_FILETYPES = 'image/*, video/*'

export const UploadAssetModal = ({ isOpen, onClose, onAssetsCreated }) => {
    const [content, setContent] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(null)
    const [progress, setProgress] = useState(0)
    const [show, setShow] = useState(false)
    const [fileType, setFileType] = useState(null)
    const file = useRef(null)
    const key = useRef(null)
    const handleClose = () => {
        onClose()
    }

    // NOTE: _id is not used in this component, but the child returns this so needed to have it...
    const createAssets = (_id, asset) => {
        if (file.current == null) {
            console.log('no file')
            return
        }

        setIsSubmitting(true)
        const publishTo = _.flatMap(asset.publishTo, (obj) => obj.canonicalName)
        CampaignAPI.createCustomAsset(
            content,
            file.current.type.split('/')[0],
            publishTo,
            asset.caption,
            asset.schedule_date
        ).then(() => {
            onAssetsCreated()
        })
    }

    const replaceImage = (e) => {
        file.current = e.target.files[0]
        setFileType(file.current.type)
        setShow(true)
        BlobAPI.getPresignedUrl(file.current.name, file.current.type).then(
            (response) => {
                key.current = response.data.data.fields.key
                BlobAPI.uploadBlob(
                    response.data.data,
                    file.current,
                    (progressEvent) => {
                        setProgress(
                            Math.round(
                                (progressEvent.loaded * 100) /
                                    progressEvent.total
                            )
                        )
                    }
                ).then((uploadResponse) => {
                    setShow(false)
                    const mediaUrl = `${uploadResponse.request.responseURL}${key.current}`
                    setContent(mediaUrl)
                })
            }
        )
    }

    return (
        <Modal open={isOpen} onClose={handleClose} size="lg" variant="solid">
            <ModalOverflow>
                <ModalDialog>
                    <ModalClose />
                    <Box sx={{ display: 'flex', height: '100%' }}>
                        {isSubmitting ? (
                            <Loading />
                        ) : (
                            <>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flex: 1,
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: 2,
                                    }}
                                >
                                    <Sheet
                                        variant="outlined"
                                        sx={{
                                            width: 400,
                                            display: 'flex',
                                            flex: 1,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            m: 4,
                                            p: 4,
                                        }}
                                    >
                                        {content && (
                                            <MediaContainer url={content} />
                                        )}
                                        {show && (
                                            <DeterminateProgress
                                                value={progress}
                                            />
                                        )}
                                    </Sheet>
                                    <Box sx={{ display: 'flex' }}>
                                        <FilePickerButton
                                            size="lg"
                                            color="primary"
                                            variant="outlined"
                                            onFileChange={replaceImage}
                                            accept={ALLOWED_FILETYPES}
                                        />
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flex: 1,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <SchedulerForm
                                        onSubmit={createAssets}
                                        id={-1}
                                        fileType={fileType}
                                    />
                                </Box>
                            </>
                        )}
                    </Box>
                </ModalDialog>
            </ModalOverflow>
        </Modal>
    )
}
